import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./win-product.scss"
import ConcurseService from "../../../shared/services/concourse-service"
import MyPointsService from "../../../shared/services/my-points-service"
import { randomBytes } from "crypto"
import { contenidoRedencion, contenidoRedencionAR } from "./jsonContent.js"
import { siteUrl } from "../../../shared/utils/siteUrl"

/* steps components */
import StepZero from "../../atoms/steps-win-product/step-zero/step-zero"
import StepOne from "../../atoms/steps-win-product/step-one/step-one"
import StepTwo from "../../atoms/steps-win-product/step-two/step-two"
import StepThree from "../../atoms/steps-win-product/step-three/step-three"
import StepFour from "../../atoms/steps-win-product/step-four/step-four"
import StepUpdateData from "../../atoms/steps-win-product/step-update-data/step-update-data"

export const SAMPLE_STEP_KEY = "SAMPLE_STEP"
export const WIN_SAMPLE_ID = "win-sample"

export function findPos(obj, defValue) {
  if (obj) {
    let curtop = 0
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop
      } while ((obj = obj.offsetParent))
      return curtop
    }
  }
  return !isNaN(defValue) && defValue !== null ? defValue : 0
}

const WinProduct = ({ step, setShowWinSample, params, mobile, setModalActive }) => {
  const [actualStep, setActualStep] = useState(step)
  const [count, setCount] = useState(0)
  const [hasError, setHasError] = useState(false)
  const [answer, setAnswer] = useState("")
  const [myKey, setMyKey] = useState("")
  const [availablePoints, setAvailablePoints] = useState()
  const [randomNum, setRandomNum] = useState(0)
  const [randomQuestion, setRandomQuestion] = useState({})
  const [servOk, setServOk] = useState(true)
  const [servMessage, setServMessage] = useState("")
  const [tokenID, setTokenID] = useState()
  const [handleButtonForm, setHandleButtonForm] = useState(false)

  const CONTENT_JSON = process.env.LOCALE == "es-AR" ? contenidoRedencionAR : contenidoRedencion

  const resultQuery = useStaticQuery(
    graphql`
        query TERMS_QUERY_COUNSULTING {
            allContentfulNolFooter {
                nodes {
                    node_locale
                    politicaPrivacidadDatos
                    terminosYCondiciones
                    redireccionTerminosYCondiciones
                }
            }
        }
    `,
  )

  var footerInfo = resultQuery.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE,
  )[0]
  var urlPoliticaPrivacidadDatos = footerInfo.redireccionPoliticaPrivacidadDatos
  var urlTerminosCondiciones = footerInfo.redireccionTerminosYCondiciones

  // const colors = params.coloresMuestreo.split(",")
  const colores = params.colorMuestreo
  // const redencion = params.tieneRedencion
  const competitionId = params.idActividadMuestreo
  const costRedeem = parseInt(params.valorActividadMuestreo)
  var homeLink = siteUrl + "/"

  function createCssStyle(styleName, styleValues) {
    if (typeof document !== "undefined") {
      var isStyleSet = !!document.getElementById(styleName)
      if (!isStyleSet) {
        var style = document.createElement("style")
        style.type = "text/css"
        style.innerHTML = `.${styleName} { ${styleValues} }`
        style.id = styleName
        document.getElementsByTagName("head")[0].appendChild(style)
      }
    }
  }

  function randomNumber(min, max) {
    return Math.floor(Math.random() * max) + min
  }

  function randomKey() {
    const random = randomBytes(10).toString()
    return random
  }


  // console.log('Estos son los colores', colors)
  // console.log('Estas son las preguntas', params.preguntasMuestreo)

  // createCssStyle(
  //   "background-color-gradient",
  //   `background: transparent
  //   linear-gradient(90deg, ${colors[1]} 0%, ${colors[2]} 57%, ${colors[1]} 100%) 0% 0% no-repeat
  // padding-box;`,
  // )
  createCssStyle(
    "background-color-primary",
    `background: ${colores[0].colorLaterales} 0% 0% no-repeat padding-box;`,
  )// amarillo
  createCssStyle(
    "background-color-primary-button",
    `background: ${colores[0].colorBotonPrimario} 0% 0% no-repeat padding-box;`,
  )
  createCssStyle(
    "background-color-secondary",
    `background: ${colores[0].colorBotonSecundario} 0% 0% no-repeat padding-box;`,
  )// rosa
  createCssStyle(
    "background-color-tertiary",
    `background: ${colores[0].colorBotonPrimario} 0% 0% no-repeat padding-box;`,
  )// azul

  createCssStyle(
    `background-color-question`,
    `background: ${colores[0].colorFondoPregunta} 0% 0% no-repeat padding-box;`,
  )

  createCssStyle(
    "background-color-quaternary",
    `background: ${colores[0].colorTitulo} 0% 0% no-repeat padding-box;`,
  )// azul

  // createCssStyle(
  //   "background-color-quinary",
  //   `background: ${colors[4]} 0% 0% no-repeat padding-box;`,
  // )// azul


  createCssStyle("text-color-primary", `color: ${colores[0].colorNumeracion} !important;`)// amarillo
  createCssStyle("text-color-secondary", `color: ${colores[0].colorTitulo} !important;`)// rosa
  createCssStyle("text-color-tertiary", `color: ${colores[0].colorSubTitulo} !important;`)// azul
  createCssStyle("text-color-quaternary ", `color: ${colores[0].colorTitulo} !important;`)// azul
  createCssStyle("text-color-question ", `color: ${colores[0].colorTextoPregunta} !important;`)// azul
  createCssStyle("text-color-sixty ", `color: ${colores[0].colorInstrucciones} !important;`)// azul

  // createCssStyle("text-color-quinary", `color: ${colors[4]} !important;`)// azul

  createCssStyle("text-color-white", `color: #ffffff !important;`)// blanco

  // createCssStyle("border-color-primary", `border: 5px solid ${colors[0]};`)
  createCssStyle("label-color-input", `color: ${colores[0].colorTitulo};`)
  createCssStyle("border-color-input", `border: 1px solid ${colores[0].colorTitulo};`)

  const ColorFinalText = colores[0].colorSubTitulo

  if (Array.isArray(params.preguntasMuestreo)) {
    console.log(`params.preguntasMuestreo`, params.preguntasMuestreo)
    params.preguntasMuestreo.forEach(({ color, textColor }, index) => {
      if (color) {
        createCssStyle(
          `background-color-question-${index}`,
          // `background: ${colors[index]} 0% 0% no-repeat padding-box;`,
        )

      }
      if (textColor) {
        createCssStyle(`text-color-question-${index}`, `color: ${textColor}`)
      }
    })
  }

  const handleAquirePoints = e => {
    e.preventDefault()
    setServMessage("")
    setServOk(true)

    if (tokenID && myKey) {
      let config = {
        headers: {
          Authorization: tokenID,
        },
      }

      let payload = {
        activity: "Muestreo Agua de Rosas",
        key: {
          code: myKey.toUpperCase().replace(/\s/g, ""),
        },
      }

      MyPointsService.postMyKeys(payload, false, config).then(res => {
        if (res.status === 200) {
          setAvailablePoints(points => points + res.data.points)
          setServOk(true)
          setServMessage(res.userMessage)
        } else {
          console.error(res)
          setServOk(false)
          setServMessage(res.userMessage)
        }
      })
    }
  }

  const handleSubmit = async (e) => {

    e.preventDefault()

    if (handleButtonForm) return
    setHandleButtonForm(true)

    if (answer) {
      setServMessage("")
      setServOk(true)
      setHasError(false)

      let config = {
        headers: {
          Authorization: tokenID,
        },
      }

      let payload = {
        competitionId,
        description: `${randomNum + 1} | ${answer}`,
      }

      await ConcurseService.postCompetitionRedeem(payload, config).then(res => {
        if (res.status === 200) {
          sessionStorage.setItem(SAMPLE_STEP_KEY, actualStep + 1)
          window.location.href =
            window.location.pathname +
            window.location.search +
            window.location.hash
        } else {
          setServOk(false)
          console.error(res)
          setServMessage(res.userMessage)
        }
      })
    } else {
      setHasError(true)
    }

    setTimeout(
      () => setHandleButtonForm(false),
      3000,
    )
  }

  useEffect(() => {
    var tokenInfo = localStorage.getItem("TOKEN_INFO")
    var userInfo = localStorage.getItem("USER_INFO")
    const isUserAuth = !!tokenInfo && !!userInfo
    if (isUserAuth) {
      const { idToken } = JSON.parse(tokenInfo)
      const { userPoints } = JSON.parse(userInfo)
      setTokenID(idToken)

      setAvailablePoints(
        +userPoints.pointsAccumulation + +userPoints.pointsPresent,
      )
    }
  }, [])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const isRedeem = urlParams.get("redimir")
    if (isRedeem) {
      setActualStep(1)
      setShowWinSample(true)
    }
    const rand = randomNumber(0, params.preguntasMuestreo.length)
    setRandomNum(s => rand)
    setRandomQuestion(params.preguntasMuestreo[rand])
  }, [])

  useEffect(() => {
    var userInfo = localStorage.getItem("USER_INFO")
    if (userInfo) {
      const { userPoints } = JSON.parse(userInfo)
      setAvailablePoints(
        +userPoints.pointsAccumulation + +userPoints.pointsPresent,
      )
    }
  }, [actualStep])

  useEffect(() => {
    setAnswer("")
    setServOk(true)
    setServMessage("")
    setCount(0)
    const rand = randomNumber(0, params.preguntasMuestreo.length)
    setRandomNum(s => rand)
    setRandomQuestion(params.preguntasMuestreo[rand])
    if (step === 1) {
      const storedStep = sessionStorage.getItem(SAMPLE_STEP_KEY)
      if (storedStep) {
        sessionStorage.removeItem(SAMPLE_STEP_KEY)
        setActualStep(s => +storedStep)
        setShowWinSample(true)
      }
    }
  }, [actualStep])

  let details = []
  let listItems = []

  let canRedeem = availablePoints >= costRedeem

  const ACTIVITY_ID_MUESTREO = params.idActividadMuestreo

  return (
    <div id={WIN_SAMPLE_ID} className="f-win-product">
      {(!actualStep || actualStep === 0) && (
        <StepZero
          setActualStep={setActualStep}
          setShowWinSample={setShowWinSample}
          params={params}
          randomKey={randomKey}
        />
      )}
      {actualStep === 1 && (
        <StepOne
          details={details}
          listItems={listItems}
          params={params}
          randomKey={randomKey}
          homeLink={homeLink}
          urlTerminosCondiciones={urlTerminosCondiciones}
          footerInfo={footerInfo}
          tokenID={tokenID}
          setActualStep={setActualStep}
          actualStep={actualStep}
          SAMPLE_STEP_KEY={SAMPLE_STEP_KEY}
          mobile={mobile}
          ACTIVITY_ID_MUESTREO={ACTIVITY_ID_MUESTREO}
          ColorFinalText={ColorFinalText}
        />
      )}
      {actualStep === 2 && (
        <StepTwo
          contenidoRedencion={CONTENT_JSON}
          randomKey={randomKey}
          canRedeem={canRedeem}
          setActualStep={setActualStep}
          actualStep={actualStep}
          myKey={myKey}
          setMyKey={setMyKey}
          servMessage={servMessage}
          servOk={servOk}
          costRedeem={costRedeem}
          handleAquirePoints={handleAquirePoints}
          availablePoints={availablePoints}
          ACTIVITY_ID_MUESTREO={ACTIVITY_ID_MUESTREO}
        />
      )}

      {actualStep === 5 && (
        <StepUpdateData
          ACTIVITY_ID_MUESTREO={ACTIVITY_ID_MUESTREO}
          setActualStep={setActualStep}
          setModalActive={setModalActive}

        />
      )}

      {actualStep === 3 && (
        <StepThree
          details={details}
          params={params}
          randomKey={randomKey}
          handleSubmit={handleSubmit}
          randomNum={randomNum}
          randomQuestion={randomQuestion}
          answer={answer}
          setAnswer={setAnswer}
          setCount={setCount}
          count={count}
          hasError={hasError}
          servOk={servOk}
          servMessage={servMessage}
          ACTIVITY_ID_MUESTREO={ACTIVITY_ID_MUESTREO}
        />
      )}


      {actualStep === 4 && (
        <StepFour
          details={details}
          params={params}
          randomKey={randomKey}
          setShowWinSample={setShowWinSample}
          setActualStep={setActualStep}
          ACTIVITY_ID_MUESTREO={ACTIVITY_ID_MUESTREO}
        />
      )}
    </div>
  )
}

export default WinProduct
